import '../../stylesheets/catalog_list.css'
import '../bootstrap_modal_common';

$(document).ready(function() {
  // 定数
  const catalogPublishFlg = document.getElementById('customer_flg14_0');
  const catalogStopFlg = document.getElementById('customer_flg14_1');
  const catalogList = document.getElementById('catalog_list');
  const catalogDetailArea = document.getElementById('catalog_detail_area');
  const publishConfirmBtn = document.getElementById('publish_confirm');
  const catalogRadioBtns = catalogDetailArea ? Array.from(catalogList.querySelectorAll('fieldset .catalog_radio_btn')) : [];

  // カタログ選択配布画面操作用JS
  const catalogFormUtil = {
    init: function() {
      if(catalogDetailArea && catalogStopFlg.checked) {
        catalogDetailArea.classList.add('d-none');
      };
      if(document.getElementById('errorExplanation') && catalogPublishFlg.checked){
        catalogFormUtil.showCatalogList();
      };
    },
    // カタログ一覧表示切替
    toggleDisplayStatus: function() {
      if(this == catalogPublishFlg) {
        publishConfirmBtn.classList.remove('d-none');
        catalogDetailArea.classList.remove('d-none');
      }else if(this == catalogStopFlg){
        catalogList.classList.add('d-none');
        catalogDetailArea.classList.add('d-none');
      };  
    },
    // カタログ一覧表示
    showCatalogList: function() {
      publishConfirmBtn.classList.add('d-none');
      catalogList.classList.remove('d-none');
      catalogRadioBtns.forEach(function(element) {
        catalogFormUtil.toggleOverlay(element);
      });
    },
    // カタログ画像グレーアウト切り替え
    toggleOverlay: function(element) {
      const target = element.target ? element.currentTarget : element;
      const parent = target.closest("fieldset");
      const catalogImage = parent.getElementsByClassName('catalog_image')[0];
      const overlay = parent.getElementsByClassName('catalog_image_overlay')[0];
      const useFlg = target.checked && target.value == 'true';

      if (!target.checked || !catalogImage) { return true };

      if (useFlg) {
        if (overlay) { overlay.remove() };
      }else {
        if (!overlay) {
          catalogImage.insertAdjacentHTML('afterend', '<div class="catalog_image_overlay"></div>');
        };
      };
    }
  };

  // サンプルダイアログ表示用JS
  const SampleDialogManager = {
    // ダイアログ表示
    openDialog: async function(element) {
      const ids = Array.from(element.currentTarget.dataset.ids.split(','));
      await SampleDialogManager.renderTemplate(ids);

      let dialog = 
        new bootstrap.Modal(document.getElementById('sampleCatalogArea'), {
          backdrop: 'static',
          focus: false,
          keybord: false
        });
      dialog.show();
    },
    // ダイアログテンプレート呼出
    renderTemplate: async function(ids){
      const csrfToken = document.getElementsByName('csrf-token')[0].content;
      const requestBody = { "ids": ids };

      await fetch('ajax_sample_catalog_dialog', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify(requestBody)
      })
      .then(response => response.text())
      .then(template => {
        document.getElementById('sampleCatalogArea').innerHTML = template;
      })
    }
  };

  // 初期処理
  catalogFormUtil.init();

  // イベント付加
  if (catalogDetailArea) {
    catalogPublishFlg.addEventListener('click', catalogFormUtil.toggleDisplayStatus);
    catalogStopFlg.addEventListener('click', catalogFormUtil.toggleDisplayStatus);
    publishConfirmBtn.addEventListener('click', catalogFormUtil.showCatalogList);
    catalogRadioBtns.forEach(function(element) {
      element.addEventListener('click', catalogFormUtil.toggleOverlay);
    });
    Array.from(catalogList.querySelectorAll('.open-sample-dialog')).forEach(function(element) {
      element.addEventListener('click', SampleDialogManager.openDialog);
    });
  };
});